import { render } from "./MemberPerkiEditModal.vue?vue&type=template&id=580750c2&scoped=true"
import script from "./MemberPerkiEditModal.vue?vue&type=script&lang=js"
export * from "./MemberPerkiEditModal.vue?vue&type=script&lang=js"

import "./MemberPerkiEditModal.vue?vue&type=style&index=0&id=580750c2&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580750c2"]])

export default __exports__